<div class="not-found">
  <div class="container text-center mt-n4">
    <h1 class="title">Página no encontrada</h1>
    <img width="500px" src="/assets/images/LOGO-55.png">
  </div>
</div>
